import { render, staticRenderFns } from "./df-card-game.vue?vue&type=template&id=f16dbbbe&scoped=true"
import script from "./df-card-game.ts?vue&type=script&lang=js&external"
export * from "./df-card-game.ts?vue&type=script&lang=js&external"
import style0 from "./df-card-game.vue?vue&type=style&index=0&id=f16dbbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16dbbbe",
  null
  
)

export default component.exports